import React from 'react'
import ReactWhatsapp from "react-whatsapp";


function Ourstore() {
    return (
        <div>
            <div className="album py-2">
                <div className="container">
                    <div className='colorchaclate'>
                        <h1 className='mt-1' ><b>OUR STORE :</b></h1>
                    </div>
                </div>
            </div>
            <div className="album py-1">
                <div className="container">
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <b>KRISHNAGAR STORE </b>
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <div className='colorchaclate'>
                                        <h3><b>Krishnagar Store <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg></b></h3>
                                        <h6>Shop Address: চ্যালেঞ্জ মোড় , হাইস্ট্রিট , কৃষ্ণনগর
                                            (আমোদিনী ব্লাউজের পাশের গলিতে রিমঝিম এর পাশে ) </h6>
                                        <a className='mb-2' href='https://g.co/kgs/fnkQwzS' target="_blank" rel="noopener noreferrer"> Direction <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-left" viewBox="0 0 16 16">
                                            <path d="M7.25 6v1q-.211.451-.588.95c-.537.716-1.259 1.44-2.016 2.196l.708.708.015-.016c.652-.652 1.33-1.33 1.881-2.015V12h1.5V6h1.216a.25.25 0 0 0 .192-.41L8.192 3.23a.25.25 0 0 0-.384 0L5.842 5.59a.25.25 0 0 0 .192.41z" />
                                            <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z" />
                                        </svg></a> <br />
                                        <a class="appbuttonthelovebirds me-5 mt-2 mb-2" href="tel: 7031820115">+91 7031820115</a>
                                        <ReactWhatsapp number="+91 7031820115" className="whatsappbutton" message="I am Interested"> Whatsapp Contact</ReactWhatsapp>

                                    </div>

                                </div>
                            </div>
                        </div>
                  


                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFive">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <b> BAGULA </b>
                                </button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                               
                                    <div className='colorchaclate'>
                                        <h3><b> Bagula Store <svg xmlns="https://g.co/kgs/NCwPk8K" width="22" height="22" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg></b></h3>
                                        <h6>Shop Address : Bus stand, Bagula, West Bengal 741502</h6>
                                        <a className='mb-2' href=' https://g.co/kgs/8y8q82d' target="_blank" rel="noopener noreferrer"> Direction <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-left" viewBox="0 0 16 16">
                                            <path d="M7.25 6v1q-.211.451-.588.95c-.537.716-1.259 1.44-2.016 2.196l.708.708.015-.016c.652-.652 1.33-1.33 1.881-2.015V12h1.5V6h1.216a.25.25 0 0 0 .192-.41L8.192 3.23a.25.25 0 0 0-.384 0L5.842 5.59a.25.25 0 0 0 .192.41z" />
                                            <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z" />
                                        </svg></a> <br />
                                        <a class="appbuttonthelovebirds me-5 mt-2 mb-2" href="tel: 7031820115">+91 7031820115</a>
                                        <ReactWhatsapp number="+91 7031820115" className="whatsappbutton" message="I am Interested"> Whatsapp Contact</ReactWhatsapp>

                                    </div>
                                   
                                </div>
                            </div>
                        </div>


                        {/* <div className="accordion-item">
                            <h2 className="accordion-header" id="headingSix">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <b>6.	KANYA SIDDHI : কন্যা সিদ্ধি </b>
                                </button>
                            </h2>
                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    <h6>1 মাস থেকে 10 বছর বয়স বাচ্চা মেয়ে   এর  জন্য
                                        স্পেশাল স্কিমস. <br />
                                        মেয়াদপূর্তিতে আকর্ষণীয় সুদের হার (সর্বোচ্চ মেয়াদপূর্তির সময়কাল 12 বছর
                                    </h6>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default Ourstore